export const vehiculesData = [
  'Camionette',
  'Véhicule de tourisme, berline, SUV, coupé, mini-van',
  'Véhicule utilitaire',
  '2 roues de moins de 90 cm3',
  '2 roues de plus de 90 cm3',
  'Tricycle ou quadricycle à moteur',
  'Camion',
  'Tracteur routier',
  'Tracteur ou machine agricole',
  'Semi-remorque agricole',
  'Véhicule automoteur spécialisé',
  'Engins spéciaux',
  'Semi-remorque',
  'Remorque de moins de 750 kgs',
  'Remorque entre 750 kgs et 3500 kgs',
  'Remorque de plus de 3500 kgs',
  'Transport en commun de moins de 3500 kgs',
  'Transport en commun de plus de 3500 kgs',
  'Machine TP',
];

export const getSelectVehiculesData = vehiculesData.map((data) => ({
  label: data,
  value: data,
}));

export const typeVehiculeData = ['NEUF', 'OCCASION'];

export const getSelectTypeVehiculesData = vehiculesData.map((data) => ({
  label: data,
  value: data,
}));

export const typeEnergieVehiculeData = [
  'DIESEL',
  'ESSENCE',
  'HYBRIDE',
  'ELECTRIQUE',
  'GAZ',
];

export const getSelectTypeEnergieVehiculeData = vehiculesData.map((data) => ({
  label: data,
  value: data,
}));

export const casParticulierActivitesData = [
  'Activité de taxi',
  'Transport en commun',
  'Véhicule utilitaire utilisés par les agriculteurs, pisciculteurs, pêcheurs et aquaculteurs',
  'Véhicule aménagé pour handicapé',
];

export const tabGenreVehiculeData = [
  {
    genre: 'Véhicule de tourisme, berline, SUV, coupé, mini-van',
    code_genre: 'VP',
    soumis_tmc: 'OUI',
    energie_puissance_renseigner: 'OUI',
    montant_taxe_environnement: 15000,
    cas_particuliers: 'OUI',
  },
  {
    genre: 'Camionette',
    code_genre: 'CTTE',
    soumis_tmc: 'OUI',
    energie_puissance_renseigner: 'OUI',
    montant_taxe_environnement: 50000,
    cas_particuliers: 'OUI',
  },
  {
    genre: 'Véhicule utilitaire',
    code_genre: 'CTTE',
    soumis_tmc: 'OUI',
    energie_puissance_renseigner: 'OUI',
    montant_taxe_environnement: 50000,
    cas_particuliers: 'OUI',
  },
  {
    genre: '2 roues de moins de 90 cm3',
    code_genre: 'CYCLO',
    soumis_tmc: 'EXO',
    energie_puissance_renseigner: 'OUI',
    montant_taxe_environnement: 5000,
    cas_particuliers: 'NON',
  },
  {
    genre: '2 roues de plus de 90 cm3',
    code_genre: 'MTTE / MTL1 / MTL2 / MTL3',
    soumis_tmc: 'OUI',
    energie_puissance_renseigner: 'OUI',
    montant_taxe_environnement: 5000,
    cas_particuliers: 'NON',
  },
  {
    genre: 'Tricycle ou quadricycle à moteur',
    code_genre: 'TQM',
    soumis_tmc: 'OUI',
    energie_puissance_renseigner: 'OUI',
    montant_taxe_environnement: 5000,
    cas_particuliers: 'NON',
  },
  {
    genre: 'Camion',
    code_genre: 'CAM',
    soumis_tmc: 'OUI',
    energie_puissance_renseigner: 'OUI',
    montant_taxe_environnement: 90000,
    cas_particuliers: 'OUI',
  },
  {
    genre: 'Tracteur routier',
    code_genre: 'TRR',
    soumis_tmc: 'OUI',
    energie_puissance_renseigner: 'OUI',
    montant_taxe_environnement: 90000,
    cas_particuliers: 'OUI',
  },
  {
    genre: 'Tracteur ou machine agricole',
    code_genre: 'TRA / MAGA',
    soumis_tmc: 'OUI',
    energie_puissance_renseigner: 'OUI',
    montant_taxe_environnement: 90000,
    cas_particuliers: 'OUI',
  },
  {
    genre: 'Semi-remorque agricole',
    code_genre: 'SREA',
    soumis_tmc: 'EXO',
    energie_puissance_renseigner: 'NON',
    montant_taxe_environnement: 90000,
    cas_particuliers: 'NON',
  },
  {
    genre: 'Véhicule automoteur spécialisé',
    code_genre: 'VASP',
    soumis_tmc: 'OUI',
    energie_puissance_renseigner: 'OUI',
    montant_taxe_environnement: 90000,
    cas_particuliers: 'OUI',
  },
  {
    genre: 'Engins spéciaux',
    code_genre: 'ENSP',
    soumis_tmc: 'OUI',
    energie_puissance_renseigner: 'OUI',
    montant_taxe_environnement: 90000,
    cas_particuliers: 'OUI',
  },
  {
    genre: 'Semi-remorque',
    code_genre: 'SREM',
    soumis_tmc: 'EXO',
    energie_puissance_renseigner: 'NON',
    montant_taxe_environnement: 90000,
    cas_particuliers: 'NON',
  },
  {
    genre: 'Remorque de moins de 750 kgs',
    code_genre: 'REM ou REA',
    soumis_tmc: 'EXO',
    energie_puissance_renseigner: 'NON',
    montant_taxe_environnement: 5000,
    cas_particuliers: 'NON',
  },
  {
    genre: 'Remorque entre 750 kgs et 3500 kgs',
    code_genre: 'REM ou REA',
    soumis_tmc: 'EXO',
    energie_puissance_renseigner: 'NON',
    montant_taxe_environnement: 15000,
    cas_particuliers: 'NON',
  },
  {
    genre: 'Remorque de plus de 3500 kgs',
    code_genre: 'REM ou REA',
    soumis_tmc: 'EXO',
    energie_puissance_renseigner: 'NON',
    montant_taxe_environnement: 90000,
    cas_particuliers: 'NON',
  },
  {
    genre: 'Transport en commun de moins de 3500 kgs',
    code_genre: 'TCP1',
    soumis_tmc: 'OUI',
    energie_puissance_renseigner: 'OUI',
    montant_taxe_environnement: 50000,
    cas_particuliers: 'OUI',
  },
  {
    genre: 'Transport en commun de plus de 3500 kgs',
    code_genre: 'TCP2',
    soumis_tmc: 'OUI',
    energie_puissance_renseigner: 'OUI',
    montant_taxe_environnement: 70000,
    cas_particuliers: 'OUI',
  },
  {
    genre: 'Machine TP',
    code_genre: 'MATP',
    soumis_tmc: 'OUI',
    energie_puissance_renseigner: 'OUI',
    montant_taxe_environnement: 90000,
    cas_particuliers: 'NON',
  },
];

export const baseCalculTMC1Data = [
  {
    energie: 'ESSENCE',
    puissancePlancherTmc: 0,
    puissancePlafondTmc: 5,
    taux_occasion_tmc: 0.04,
    taux_neuf_tmc: 0.04,
  },
  {
    energie: 'ESSENCE',
    puissancePlancherTmc: 6,
    puissancePlafondTmc: 8,
    taux_occasion_tmc: 0.07,
    taux_neuf_tmc: 0.07,
  },
  {
    energie: 'ESSENCE',
    puissancePlancherTmc: 9,
    puissancePlafondTmc: 12,
    taux_occasion_tmc: 0.08,
    taux_neuf_tmc: 0.08,
  },
  {
    energie: 'ESSENCE',
    puissancePlancherTmc: 13,
    puissancePlafondTmc: 15,
    taux_occasion_tmc: 0.09,
    taux_neuf_tmc: 0.09,
  },
  {
    energie: 'ESSENCE',
    puissancePlancherTmc: 16,
    puissancePlafondTmc: 10000,
    taux_occasion_tmc: 0.11,
    taux_neuf_tmc: 0.11,
  },
  {
    energie: 'DIESEL',
    puissancePlancherTmc: 0,
    puissancePlafondTmc: 7,
    taux_occasion_tmc: 0.07,
    taux_neuf_tmc: 0.07,
  },
  {
    energie: 'DIESEL',
    puissancePlancherTmc: 8,
    puissancePlafondTmc: 15,
    taux_occasion_tmc: 0.09,
    taux_neuf_tmc: 0.09,
  },
  {
    energie: 'DIESEL',
    puissancePlancherTmc: 16,
    puissancePlafondTmc: 10000,
    taux_occasion_tmc: 0.11,
    taux_neuf_tmc: 0.11,
  },
  {
    energie: 'HYBRIDE',
    puissancePlancherTmc: 0,
    puissancePlafondTmc: 10000,
    taux_occasion_tmc: 0.03,
    taux_neuf_tmc: 0,
  },
  {
    energie: 'ELECTRIQUE',
    puissancePlancherTmc: 0,
    puissancePlafondTmc: 10000,
    taux_occasion_tmc: 0.03,
    taux_neuf_tmc: 0,
  },
  {
    energie: 'GAZ',
    puissancePlancherTmc: 0,
    puissancePlafondTmc: 10000,
    taux_occasion_tmc: 0.03,
    taux_neuf_tmc: 0.03,
  },
];

export const baseCalculTMC2Data = [
  {
    activite: 'Activité de taxi',
    taux: 0.04,
    soumis_tmc: 'OUI',
  },
  {
    activite: 'Transport en commun',
    taux: 0.04,
    soumis_tmc: 'OUI',
  },
  {
    activite:
      'Véhicule utilitaire utilisés par les agriculteurs, pisciculteurs, pêcheurs et aquaculteurs',
    taux: 0.04,
    soumis_tmc: 'OUI',
  },
  {
    activite: 'Véhicule aménagé pour handicapé',
    taux: 0,
    soumis_tmc: 'EXO',
  },
];
